const ENV_ID = process.env.REACT_APP_ENV_ID!
const MENTORS_STUDY_DB = process.env.REACT_APP_MENTORS_STUDY_DB!
const MENTORS_WORK_DB = process.env.REACT_APP_MENTORS_WORK_DB!
const ORDERS_STUDY_DB = process.env.REACT_APP_ORDERS_STUDY_DB!
const ORDERS_WORK_DB = process.env.REACT_APP_ORDERS_WORK_DB!

export { ENV_ID, MENTORS_STUDY_DB, MENTORS_WORK_DB, ORDERS_STUDY_DB, ORDERS_WORK_DB }
